import React, {useEffect} from "react";
import {useSearchParams} from 'react-router-dom';
import {getCookie, simplePutData} from '../../utils/Functions';
import EndPoint from "../../api/Endpoints";

import bgStadium from "../../assets/imgs/unicef/messi/thankyou/bg-stadium-dark.png";
import unicefLogo from "../../assets/imgs/unicef/messi/thankyou/unicef-logo-white.png";

import "./MessiDonacionError.css";

const MessiDonacionError = () => {
    const [searchParams] = useSearchParams();
    const errorMessage = searchParams.get("error") || "Error desconocido";

    useEffect(() => {
        setTimeout(() => window.scrollTo(0, 0), 100);

        var _tmpOrder = getCookie(process.env.REACT_APP_NAME + "_DFP_session_id");
        let utm_source = getCookie(process.env.REACT_APP_NAME + "utm_source");
        let stepValues = {
            step: "checkout-finish-NOK",
            utm_source: utm_source,
            sessionid: _tmpOrder
        };
        simplePutData(EndPoint.setStep, stepValues);
    }, []);

    return (
        <div className="messi-error">
            <img src={bgStadium} alt="" className="messi-error-bg"/>

            <div className="messi-error-content">
                <div className="messi-error-card">
                    <img src={unicefLogo} alt="UNICEF" className="messi-error-logo"/>

                    <div className="messi-error-icon">
                        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="32" cy="32" r="30" stroke="#ff4d4d" strokeWidth="3" fill="rgba(255,77,77,0.1)"/>
                            <line x1="22" y1="22" x2="42" y2="42" stroke="#ff4d4d" strokeWidth="3" strokeLinecap="round"/>
                            <line x1="42" y1="22" x2="22" y2="42" stroke="#ff4d4d" strokeWidth="3" strokeLinecap="round"/>
                        </svg>
                    </div>

                    <h2 className="messi-error-title font-face-UniversBold">
                        Hubo un problema procesando tu donaci&oacute;n
                    </h2>

                    <div className="messi-error-message">
                        <p>La respuesta del banco fue:</p>
                        <strong>{errorMessage}</strong>
                    </div>

                    <p className="messi-error-help">
                        No te preocupes, puedes volver a intentarlo. Verifica los datos de tu tarjeta e int&eacute;ntalo nuevamente.
                    </p>

                    <a href="/lapolerademessi" className="messi-error-btn font-face-UniversBold">
                        VOLVER A INTENTAR
                    </a>

                    <p className="messi-error-footer">
                        Recuerda que tambi&eacute;n puedes donar con <strong>QR</strong> como m&eacute;todo alternativo.
                    </p>
                </div>
            </div>
        </div>
    );
};

MessiDonacionError.propTypes = {};

export default MessiDonacionError;
